import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { addShipmentPostings, changeShipmentPostingMany } from '../../../../actions/postings';
import { uiChangeShipmentMode } from '../../../../actions/ui';
import PostingsApi from '../../../../API/shipment/postings-api';
import RealizationApi from '../../../../API/shipment/realization-api';
import ShipmentsApi from '../../../../API/shipment/shipments-api';
import ShipmentWorkApi from '../../../../API/shipment/work-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../../components/Basic/Buttons';
import { LinkBlue } from '../../../../components/Basic/Elements';
import { Content } from '../../../../components/Basic/Global';
import { DateInput, Input, Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../../components/Basic/Table';
import { H1, H3, Text } from '../../../../components/Basic/WrapsStyle';
import {
  IP_LIST,
  IP_NUMBER_MAP,
  MARKETS_ALL,
  REALIZATION_STATUS,
  STATUS_COLORS,
  TYPE_BUTTONS
} from '../../../../constans';
import { getDate, getDateMonth, numberWithSpaces } from '../../../../utils';
import PostingLine from './PostingLine';
import ResalePopUp from './ReasalePopUp/index';
import styles from './styles.module.scss';

const MARKETS = {
  ozon: ['OZON-1', 'OZON-2', 'OZON-3', 'OZON-4', 'OZON-5', 'OZON-6', 'OZON-7'],
  yandex: ['B-WHITE FBS', 'U-RURU FBS'],
  wb: ['WB-1', 'WB-2', 'WB-3', 'WB-4', 'WB-5', 'WB-6', 'WB-7'],
  megamarket: ['SBER-1', 'SB ER-2'],
};

const SHOPS = {
  ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];

const MODES = ['Режим отгрузки', 'Режим докупов', 'Честный знак'];
const MODES_OWNER = ['Режим реализации', 'Режим отгрузки'];

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
  '80px', // 14
  '40px', //15
];

const STATUSES = [
  'Не выбран',
  'Нет в наличии',
  'Резерв',
  'Частичный резерв',
  'Излишки',
  'Не хватает',
  'Приехало на отгрузку',
  'Отгрузка со склада',
];

const STATUSES_ALL = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];

const STATUSES_ORDERS_WB = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];

const STATUSES_ORDERS_OZON = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
];

const STATUSES_ORDERS_SBER = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Отменено',
  'Отменено клиентом',
];

const STATUSES_ORDERS_YANDEX = ['Не выбран', 'Ожидает отгрузки', 'Доставляется', 'Продано', 'Отменено'];

const STATUSES_ORDERS = {
  ozon: STATUSES_ORDERS_OZON,
  yandex: STATUSES_ORDERS_YANDEX,
  wb: STATUSES_ORDERS_WB,
  megamarket: STATUSES_ORDERS_SBER,
  ALL: STATUSES_ALL,
};
const STATUSES_SHIPMENT = ['Не выбран', 'Разложен (не упакован)', 'Упакован', 'Не отсортированы', 'Отсортированы'];

const FILTER = {
  0: 'all',
  1: 'op3',
  2: 'op2',
  3: 'op1',
  4: 'op0',
  5: 'not_purchase',
  6: 'not_enough', // не хвататет
  7: 'not_ip',
  8: "op_empty"
};
/* const FILTER = {
  0: 'all',
  1: 'delivering',
  2: 'sold',
  3: 'canceled',
  4: 'canceled_return',
}; */

const CHZN = {
  'Не выбран': null,
  Да: true,
  Нет: false,
};

function RealizationPage({ isExpress = false }) {
  const { id } = useParams();

  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();
  const [shipment, setShipment] = useState({ market: '', shop: '', date_realization: '' });
  const [shipments, setShipments] = useState([]);

  const [load, setLoad] = useState(false);
  const [calc, setCalc] = useState({ profit: 0, price: 0, purchase: 0, other: 0, market_payment: 0 });
  const [saleSchema, setSaleSchema] = useState('Не выбрана');
  const [IPSelect, setIPSelect] = useState({ name: 'Не выбран', id: undefined });
  const [ipChange, setIpChange] = useState(IP_LIST[0]);

  const [checkAll, setCheckAll] = useState(false);

  const [packagingMode, changePackagingMode] = useState(false);

  const shipmentMode = useSelector((store) => store.ui.shipment_mode) || 'Режим отгрузки';

  const [openOperationWindow, setOpenOperationWindow] = useState(false);

  const [postingsSelect, setPostingsSelect] = useState({});

  const [isMany, setIsMany] = useState(isExpress);

  const [marketMany, setMarketMany] = useState(MARKETS_LIST[0]);
  const [shopName, setShopName] = useState('Все');
  const [shop, setShop] = useState('');

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();
  const [reportType, setReportType] = useState('Не выбран');

  const [market, setMarket] = useState(Object.keys(MARKETS)[0]);
  const [dateFinance, setDateFinance] = useState(new Date());
  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');

  const [rates, setRates] = useState({});
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [chzn, setChzn] = useState('Не выбран');

  const [status, changeStatus] = useState(STATUSES[0]);
  const [statusShipment, changeStatusShipment] = useState(STATUSES_SHIPMENT[0]);

  const [orderStatus, changeOrderStatus] = useState('Не выбран');
  const [stocks1cArray, setStocks1cArray] = useState([]);
  const [statistic, setStatistic] = useState([]);

  const { ids = [], byIds = {}, map = {} } = useSelector((store) => store.postings);

  const onChangeRealization = (key, value) => {
    RealizationApi.changeRealization({ data: { realizationId: shipment.id, field: key, value } }).then(() => loadData());
  };

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  useEffect(() => {
    setMarket(Object.keys(MARKETS)[0]);
  }, []);

  const params = useMemo(() => {
    const s = status === STATUSES[0] ? '' : status;
    const shop_name = shopName === 'Все' ? '' : shopName;
    const order_status = orderStatus === 'Не выбран' ? '' : orderStatus;
    const shipment_status = statusShipment === 'Не выбран' ? '' : statusShipment; //статус отгрузки заказа

    let realizations_ids = undefined;

    realizations_ids = id.split('&');
    realizations_ids = realizations_ids.map((item) => parseInt(item));

    return {
      pageName: 'realizations',
      realizationIds: realizations_ids,
      shipmentFilter: isExpress
        ? {
          isExpress,
          shipmentState: 'started',
        }
        : undefined,
      limit: parseInt(show),
      page,
      search: search.trim(),
      providerId: provider.id,
      tab: FILTER[tab],
      market: realizations_ids?.length === 1 || marketMany === 'Не выбрана' ? undefined : marketMany.toLowerCase(),
      shop: shop_name,
      sortType: 'shipments',
      saleSchema: saleSchema === 'Не выбрана' ? undefined : saleSchema,

      filters: {
        orderStatus: order_status,
        stateStatus: shipment_status,
        productsStatus: s,
        chzn: CHZN[chzn],
      },
      ipFilter: {
        from: IPSelect.id,
      },
    };
  }, [
    id,
    show,
    page,
    search,
    tab,
    provider.id,
    status,
    shopName,
    orderStatus,
    statusShipment,
    marketMany,
    chzn,
    saleSchema,
    IPSelect,
  ]);

  const loadData = () => {
    RealizationApi.getRealizedPostings({ data: params })
      .then((res) => {
        const { data, postings, cardsMap, count, all_count, finances } = res;
        const byIds = {};

        setStatistic(res.statistic);
        setCountStock([
          all_count.all,
          all_count.op3,
          all_count.op2,
          all_count.op1,
          all_count.op0,
          all_count.not_purchase,
          all_count.not_enough,
          all_count.not_ip,
          all_count.op_empty,
        ]);

        const ids = postings.map((item) => item.posting_number);
        postings.forEach((item) => (byIds[item.posting_number] = item));

        dispatch(addShipmentPostings({ byIds, ids, map: cardsMap }));

        setPostingsSelect({});
        setCalc(finances);

        if (res.realizations.length === 1 && !isExpress) {
          setShipment(res.realizations[0]);
        } else {
          setShipments(res.realizations);
        }
        setStocks1cArray(res.stocks1cArray);

        setCount(count);
        setLoad(true);
        setShop(MARKETS_ALL[res.realizations[0].market][0]);
      })
      .catch((err) => {
        console.log(err);
        if (err.code === 140) {
          setError('Не удалось отгрузку');
        }
      });
  };

  const loadPackagingStatistic = () => {
    ShipmentsApi.getPackageStatistic({ data: { shipmentId: id } }).then((r) => setRates(r.map));
  };

  useEffect(() => {
    console.log(id);
    if (id) {
      const realizations_ids = id.split('&');
      if (isOwner && realizations_ids?.length === 1) {
        loadPackagingStatistic();
      }

      setIsMany(realizations_ids.length > 1);
    }
  }, [id]);

  useEffect(() => {
    loadData();
  }, [params]);


  const updateStocks41 = async (postingNumbers = undefined, ignoreDiffPrices = undefined, saleSchema) => {
    let realizations_ids = undefined;

    realizations_ids = id.split('&');
    realizations_ids = realizations_ids.map((item) => parseInt(item));

    await RealizationApi.reserveStocksForPostings({ data: { realizationIds: realizations_ids, postingNumbers, ignoreDiffPrices, saleSchema } })
    await loadData(id);
  };

  const onConfirm = () => {
    const MAP_OPERATION = {
      2: 'op2',
      4: 'op0',
      3: 'op1',
    };

    RealizationApi.resale({
      data: {
        ...params,
        operation1c: MAP_OPERATION[tab],
      }
    });
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  const changePostingSelect = (order_number) => {
    if (postingsSelect[order_number]) {
      const s = postingsSelect;
      delete s[order_number];
      setPostingsSelect({ ...s });
    } else {
      setPostingsSelect({ ...postingsSelect, [order_number]: true });
    }
  };

  const changePrintStatus = async (numbers = [], s) => {
    await ShipmentWorkApi.changePrint({ data: { postingNumbers: numbers, isPrint: s } }).then((r) => {
      const p = r.postings;
      const changeByIds = {};
      p.forEach((item) => {
        changeByIds[item.posting_number] = item;
      });
      dispatch(changeShipmentPostingMany(changeByIds));
    });
  };

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_print = {};
      ids.forEach((item) => {
        const order = byIds[item];

        map_print[order.posting_number] = true;
      });
      setPostingsSelect(map_print);
      setCheckAll(true);
    } else {
      setCheckAll(false);

      setPostingsSelect({});
    }
  };
  const tab_name =
    isMany || isExpress
      ? isExpress
        ? 'Экспрессы'
        : 'Cовместная отгрузка'
      : `Отгрузка: ${shipment.market || ''} ${shipment.date_realization ? getDate(shipment.date_realization) : ''}`;

  const modes = isOwner ? MODES_OWNER : MODES;

  const sum = (Object.keys(rates) || [])
    .map((key) => rates[key])
    .reduce(
      (prev, item, index) => {
        return { count: prev.count + item.count, payment: prev.payment + item.payment };
      },
      { payment: 0, count: 0 },
    );

  useEffect(() => {
    setShopName('Все');
  }, [marketMany]);

  const changeIP = async () => {
    await PostingsApi.changePostings({ data: { postingNumbers: Object.keys(postingsSelect), field: 'ip_id', value: ipChange.id } });
    loadData();
  };

  const shipments_text = shipments.map(
    (item) =>
      `${item.market || ''} ${item.is_express ? ' Express ' : ''} ${item.date_realization ? getDateMonth(item.date_realization) : ''
      }`,
  );

  return (
    <>
      <Content>
        <H1 style={{ marginBottom: '-3px' }}>
          {isMany || isExpress
            ? `Совместная реализация: ${shipments_text.join(' + ')}`
            : `Реализация: ${shipment.market || ''} ${shipment.is_express ? ' Express ' : ''} ${shipment.date_realization ? getDate(shipment.date_realization) : ''
            }`}
        </H1>
        <LinkBlue to='/report/realizations' style={{ marginBottom: '10px' }}>
          Вернуться к реализациям
        </LinkBlue>

        <Row style={{ alignItems: 'flex-start' }}>
          <WhiteBlock style={{ minWidth: '600px', alignSelf: 'normal', marginRight: '20px' }} minimize={false}>
            {!isMany && (
              <H3 style={{ marginBottom: '5px' }}>
                Статус:{' '}
                <span style={{ color: STATUS_COLORS[shipment.status] }} className={styles.status}>
                  {REALIZATION_STATUS[shipment.status]}
                </span>
              </H3>
            )}
            <Row style={{ marginTop: '10px' }}>
              <Column>
                {isOwner && (
                  <Row style={{ alignItems: 'flex-end' }}>
                    {!isMany && (
                      <>
                        <DateInput
                          label="Дата реализации"
                          classNameCalendar={styles.date_input}
                          className={styles.calendar}
                          value={shipment.date_realization}
                          disabled={true}
                          onChange={(v) => onChangeRealization('date_realization', new Date(v))}
                        />
                      </>
                    )}

                    <Button type={TYPE_BUTTONS.BLUE} onClick={() => onChangeRealization('status', 'started')}>
                      Начать реализацию
                    </Button>
                    <Button
                      type={TYPE_BUTTONS.GREEN}
                      style={{
                        marginLeft: '15px',
                      }}
                      onClick={() => onChangeRealization('status', 'ended')}
                    >
                      Заверишь реализация
                    </Button>
                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      style={{
                        marginLeft: '15px',
                      }}
                      onClick={() => updateStocks41(undefined, undefined, "fbs")}
                    >
                      Подтянуть остатки с 41-го счета fbs
                    </Button>

                    <Button
                      type={TYPE_BUTTONS.WHITE}
                      style={{
                        marginLeft: '15px',
                      }}
                      onClick={() => updateStocks41(undefined, undefined, "fbo")}
                    >
                      Подтянуть остатки с 41-го счета fbo
                    </Button>
                  </Row>
                )}
                <Row style={{ marginTop: '25px' }}>
                  <Button
                    type={TYPE_BUTTONS.GREEN}
                    onClick={() => setOpenOperationWindow(true)}
                    disabled={tab !== 2 && tab !== 3 && tab !== 4}
                  >
                    Провести операцию
                  </Button>

                  <Button
                    style={{ marginLeft: '15px' }}
                    type={TYPE_BUTTONS.GREEN}
                    onClick={() => RealizationApi.move45({ data: { realizationIds: id.split('&').map((item) => parseInt(item)) } })}
                  // disabled={tab !== 2 && tab !== 3 && tab !== 4}
                  >
                    Перекинуть 45 счет
                  </Button>
                </Row>
              </Column>
              <Column style={{ marginTop: '14px' }}></Column>
            </Row>
          </WhiteBlock>

          {(tab === 2 || tab === 3 || tab === 4) && (
            <WhiteBlock>
              {statistic?.map((s) => (
                <Row>{`${IP_NUMBER_MAP[s.ip_from]} ->  ${IP_NUMBER_MAP[s.ip_to] || s.ip_to}  :  ${numberWithSpaces(
                  s.sum,
                )} руб. / НДС: ${numberWithSpaces(s.nds_sum)} руб. `}</Row>
              ))}
            </WhiteBlock>
          )}
        </Row>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={[
                'Все продажи',
                'Реализовано на МП',
                'Готово к реализации 02',
                'Готово к реализации 01->02',
                'Перепродажа на ИП Склад',
                'Проверить цену закупки',
                'Не хватает остатка',
                'Не проставлено ИП закупочное',
                'Не обработаны',
              ]}
              isNum={true}
              num={countStock}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
            <Row>
              <div>
                <Select
                  select={shipmentMode}
                  list={modes}
                  onSelect={(v) => dispatch(uiChangeShipmentMode(v))}
                  width="250px"
                />
              </div>

              {/*
            <TextGrey style={{ marginRight: '10px' }}>Режим отгрузки</TextGrey>
            {user.role === 'owner' && <Switch switched={shipmentMode} onClick={(v) => changeShipmentMode(v)} />}*/}
            </Row>
          </Row>

          <Row className={styles.row_input}>
            {Object.keys(postingsSelect).length > 0 ? (
              <Row className={styles.row_select}>
                <Row>
                  <Button
                    type={TYPE_BUTTONS.RED}
                    style={{ marginRight: '15px' }}
                    onClick={() => {
                      setCheckAll(false);
                      setPostingsSelect({});
                      setTimeout(setInputFocus, 1000);
                    }}
                  >
                    Очистить выбор
                  </Button>

                  {tab === 5 && (
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      style={{ marginRight: '15px' }}
                      onClick={() => {
                        updateStocks41(Object.keys(postingsSelect), true);
                        setCheckAll(false);
                        setPostingsSelect({});
                      }}
                    >
                      Подвердить цены
                    </Button>
                  )}

                  {tab === 7 && (
                    <>
                      <Select
                        label="Ип Закупочное"
                        select={ipChange}
                        valueFn={(ip) => ip?.name}
                        list={IP_LIST}
                        width="200px"
                        onSelect={(v) => setIpChange(v)}
                        style={{ marginRight: '15px' }}
                      />
                      <Button type={TYPE_BUTTONS.GREEN} onClick={changeIP}>
                        Сохранить ИП
                      </Button>
                    </>
                  )}
                </Row>
              </Row>
            ) : (
              <Input
                value={search}
                ref={inputRef}
                onBlur={(v) => setSearch(v)}
                onClickEnter={(v) => setSearch(v)}
                label="Поиск"
              />
            )}
          </Row>

          <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

          <Row spaceBetween={true}>
            <Row style={{ height: '40px' }}>
              <div>
                <Select
                  label="Показать на странице"
                  select={show}
                  list={['20', '50', '100', '150', '200', '500', '1000']}
                  onSelect={(v) => setShow(v)}
                  width="150px"
                  style={{ marginRight: '15px' }}
                />
              </div>

              {isMany ? (
                <>
                  <Select
                    list={MARKETS_LIST}
                    select={marketMany}
                    label="Площадка"
                    onSelect={(v) => setMarketMany(v)}
                    width={'150px'}
                    style={{ marginRight: '15px' }}
                  />
                  <Select
                    list={SHOPS[marketMany.toLowerCase()] || []}
                    select={shopName}
                    disabled={marketMany === MARKETS_LIST[0]}
                    label="Магазин"
                    onSelect={(v) => setShopName(v)}
                    width={'150px'}
                    style={{ marginRight: '15px' }}
                  />
                </>
              ) : (
                <Select
                  label="Магазин"
                  select={shopName}
                  list={SHOPS[shipment.market]}
                  width="130px"
                  onSelect={(v) => setShopName(v)}
                  style={{ marginRight: '15px' }}
                />
              )}

              <Select
                label="Поставщик"
                select={provider}
                valueFn={(p) => p.name}
                list={providers}
                width="200px"
                onSelect={(v) => changeProvider(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Статус товара"
                select={status}
                list={STATUSES}
                width="200px"
                onSelect={(v) => changeStatus(v)}
                style={{ marginRight: '15px' }}
              />
              <Select
                label="Статус заказа"
                select={orderStatus}
                list={isMany ? STATUSES_ALL : STATUSES_ORDERS[shipment.market]}
                width="200px"
                style={{ marginRight: '15px' }}
                onSelect={(v) => changeOrderStatus(v)}
              />

              <Select
                label="Честный знак"
                select={chzn}
                list={['Не выбран', 'Да', 'Нет']}
                width="140px"
                style={{ marginRight: '15px' }}
                onSelect={(v) => setChzn(v)}
              />

              <Select
                label="Схема отгрузки"
                select={saleSchema}
                list={['Не выбрана', 'fbs', 'fbo', 'express']}
                width="200px"
                onSelect={(v) => setSaleSchema(v)}
                style={{ marginRight: '15px' }}
              />

              <Select
                label="Ип Закупочное"
                select={IPSelect}
                valueFn={(ip) => ip?.name}
                list={[{ name: 'Не выбран', id: undefined }, ...IP_LIST]}
                width="200px"
                onSelect={(v) => setIPSelect(v)}
                style={{ marginRight: '15px' }}
              />
            </Row>
            <Row>
              <Button
                type={TYPE_BUTTONS.WHITE}
                onClick={() =>
                  RealizationApi.excelProductsInRealization({
                    data: {
                      ...params,
                      limit: undefined,
                      page: undefined,
                      sortType: undefined,
                      type: 'xlsx',
                    }
                  })
                }
              >
                Выгрузить данные по позициям
              </Button>
            </Row>
          </Row>
        </WhiteBlock>

        <Table styles={styles.table}>
          <TableHeader whiteHeader>
            <HeaderTitle width={WIDTH_POSTING[15]}>
              <CheckButton checked={checkAll} onSelect={(v) => clickCheckAll(v)} />
            </HeaderTitle>

            <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[14]} centerText>
              Дата отгрузки
            </HeaderTitle>

            <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
              Количество
            </HeaderTitle>
            <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
              История операций
            </HeaderTitle>
            {shipmentMode === modes[0] && (
              <>
                <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
                  Ставка НДС
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
                  Цена закупки
                </HeaderTitle>
                {tab === 5 && (
                  <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
                    Цена на 1м счете
                  </HeaderTitle>
                )}
                {tab === 2 && (
                  <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
                    Цена для оп_02
                  </HeaderTitle>
                )}
                {tab === 3 && (
                  <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
                    Цена для оп_01
                  </HeaderTitle>
                )}
                {tab === 4 && (
                  <HeaderTitle width={WIDTH_POSTING[6]} centerText={true}>
                    Цена для оп_00
                  </HeaderTitle>
                )}
                {(tab === 6 || tab === 7) && (
                  <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                    Ип закупочное
                  </HeaderTitle>
                )}

                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Ип отгрузочное
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Заререзвировано на 41 счете
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Остаток на 41 счете
                </HeaderTitle>
              </>
            )}

            {shipmentMode === modes[0] && (
              <>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Артикул поставщика
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Артикул 1c
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Поставщик
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[5]} centerText={true}>
                  Статус товара
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Статус заказа
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[7]} centerText={true}>
                  Штрихкод товара
                </HeaderTitle>
              </>
            )}

            {shipmentMode === modes[1] && (
              <>
                <HeaderTitle width={WIDTH_POSTING[5]} centerText={true}>
                  Статус товара
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Статус заказа
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Поставщик
                </HeaderTitle>
                <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
                  Артикул поставщика
                </HeaderTitle>
              </>
            )}
          </TableHeader>
          {ids.map((order) => {
            return (
              <PostingLine
                stocks1cArray={stocks1cArray}
                shipmentMode={shipmentMode}
                packagingMode={packagingMode}
                MODES={modes}
                FILTER={FILTER}
                tab={tab}
                order={byIds[order]}
                shipment={shipment}
                map={map}
                key={byIds[order].posting_number}
                setInputFocus={setInputFocus}
                changePrintStatus={changePrintStatus}
                postingsSelect={postingsSelect}
                changePostingSelect={changePostingSelect}
                isMany={isMany}
              />
            );
          })}
        </Table>
        {openOperationWindow && (
          <ResalePopUp
            tab={tab}
            params={params}
            onClickOk={() => {
              onConfirm();
              setOpenOperationWindow(false);
              loadData();
            }}
            close={() => {
              setOpenOperationWindow(false);
              loadData();
            }}
          // onClickOk={(orders) => cancelOrders(orders)}
          />
        )}

        <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
      </Content>
    </>
  );
}

export default RealizationPage;
